<template>
    <div class="mb-5 pb-5 px-0">
        <div class="mt-5 flex flex-col md:flex-row justify-arrow">
            <div class="flex flex-col items-center md:items-start w-full">
                <h1 class="text-3xl text-center md:text-left">
                    <strong class="text-theme-primary">
                        {{ name }}
                    </strong>
                </h1>
                <div
                    class="mt-2 flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-1 sm:gap-3 w-full"
                >
                    <strong v-if="productComponent.sku" class="break-words">
                        SKU: {{ productComponent.sku }}
                    </strong>
                    <strong class="break-words">
                        Slug: {{ productComponent.slug }}
                    </strong>
                </div>
            </div>

            <div
                class="flex flex-col mt-2 md:mt-0 md:min-w-max justify-start text-center items-start"
            >
                <small> 📆💾 {{ productComponent.createdAt | date }} </small>
                <small> 📆✏ {{ productComponent.updatedAt | date }} </small>
                <small v-if="productComponent.deletedAt">
                    📆🗑️ {{ productComponent.deletedAt | date }}
                </small>
            </div>
            <div class="flex items-start justify-center mt-3 md:mt-0 px-2">
                <app-button
                    icon
                    circle
                    color="brand-purple"
                    @click="getBaseItem"
                >
                    <reload-icon class="text-white h-5 w-5" />
                </app-button>
            </div>
        </div>

        <div v-if="id" class="mt-6">
            <custom-navbar
                id="tabs-products"
                v-model="activeTab"
                center-collapsed
                not-line
            >
                <template #left>
                    <custom-navbar-item id="home">
                        <router-link
                            to="/app/products"
                            class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                        >
                            <span>🏠</span>
                        </router-link>
                    </custom-navbar-item>
                    <custom-navbar-item
                        id="general"
                        :active="['general', 'home'].includes(activeTab)"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> General&nbsp; </span>
                            <span>⚙️</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="
                            $enabledEcommerceOptions &&
                            $ability.hasPermission('product:UpdateContent')
                        "
                        id="seo"
                        :active="activeTab === 'seo'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"
                                >Contenido&nbsp;
                            </span>
                            <span>📒</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        id="references"
                        :active="activeTab === 'references'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden">
                                Variantes y Fotos&nbsp;
                            </span>
                            <span>🛍️</span>
                        </div>
                    </custom-navbar-item>

                    <custom-navbar-item
                        v-if="
                            $ability.hasPermission(
                                'product:UpdateCollections'
                            ) || $ability.hasPermission('product:UpdateLine')
                        "
                        id="routes"
                        :active="activeTab === 'routes'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden">
                                Categorías y Colecciones&nbsp;
                            </span>
                            <span>🏷️</span>
                        </div>
                    </custom-navbar-item>

                    <custom-navbar-item
                        v-if="$ability.hasPermission('product:UpdateFiles')"
                        id="files"
                        :active="activeTab === 'files'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden">
                                Archivos adjuntos&nbsp;
                            </span>
                            <span>🗂</span>
                        </div>
                    </custom-navbar-item>

                    <custom-navbar-item
                        v-if="
                            $enabledEcommerceOptions &&
                            $ability.hasPermission('product:UpdateExtraOptions')
                        "
                        id="extraOptions"
                        :active="activeTab === 'extraOptions'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden">
                                Opciones Extra&nbsp;
                            </span>
                            <span>🎲</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="
                            $enabledEcommerceOptions &&
                            $ability.hasPermission('logisticConfiguration:List')
                        "
                        id="delivery"
                        :active="activeTab === 'delivery'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Entrega&nbsp; </span>
                            <span>🚚</span>
                        </div>
                    </custom-navbar-item>
                </template>
                <template #right>
                    <div class="hidden md:block mr-2">
                        <custom-switch
                            v-if="$ability.hasPermission('product:Update')"
                            v-model="enabledUpdate"
                        >
                            <span class="text-theme-inverse">🖊</span>
                        </custom-switch>
                    </div>
                    <dropdown-popover class="mr-2" shadow border-thick>
                        <custom-avatar
                            pointer
                            size="large"
                            circle
                            class="bg-theme-primary text-theme-inverse"
                        >
                            <span> ⚙ </span>
                        </custom-avatar>
                        <template #tooltip>
                            <div class="flex flex-col items-start py-3">
                                <div
                                    v-if="
                                        $ability.hasPermission('product:Update')
                                    "
                                    class="md:m-2 m-1"
                                >
                                    💰
                                    <button
                                        class="font-bold btn-a md:ml-2 ml-1"
                                        aria-label="Actualizar precios"
                                        @click="openPricesModal"
                                    >
                                        Actualizar precios
                                    </button>
                                </div>
                                <div
                                    v-if="
                                        $ability.hasPermission(
                                            'order:ListReferences'
                                        )
                                    "
                                    class="md:m-2 m-1"
                                >
                                    📈
                                    <a
                                        class="font-bold btn-a md:ml-2 ml-1"
                                        aria-label="Product sales"
                                        :href="`/app/orders/product/${productComponent.id}`"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        Ventas de producto
                                    </a>
                                </div>
                                <div
                                    v-if="
                                        $ability.hasPermission('product:Delete')
                                    "
                                    class="md:m-2 m-1"
                                >
                                    🔴
                                    <button
                                        class="font-bold btn-a md:ml-2 ml-1"
                                        aria-label="Delete product force"
                                        @click="deleteItemComponent"
                                    >
                                        Eliminar producto
                                    </button>
                                </div>
                                <div
                                    v-if="
                                        $ability.hasPermission(
                                            'product:DeleteDefinitive'
                                        )
                                    "
                                    class="md:m-2 m-1"
                                >
                                    🛑
                                    <button
                                        class="font-bold btn-a md:ml-2 ml-1"
                                        aria-label="Delete product force"
                                        @click="deleteItemDefinitelyComponent"
                                    >
                                        Eliminación definitiva
                                    </button>
                                </div>
                            </div>
                        </template>
                    </dropdown-popover>
                </template>
            </custom-navbar>
        </div>

        <div
            v-if="$ability.hasPermission('product:Update') && id"
            class="flex justify-center"
        >
            <div class="block md:hidden my-3">
                <custom-switch v-model="enabledUpdate">
                    <span class="text-theme-inverse">🖊</span>
                </custom-switch>
            </div>
        </div>

        <div
            v-show="['general', 'home', 'others'].includes(activeTab)"
            id="generalTab"
        >
            <div id="general-title" class="flex flex-wrap">
                <div class="flex flex-col">
                    <h2 class="text-theme-primary text-2xl font-semibold mt-4">
                        Características generales
                    </h2>
                    <span class="mt-4">
                        Determina las características principales del producto.
                        El precio del producto es un reflejo del precio de la
                        referencia por defecto.
                    </span>
                </div>
            </div>

            <div v-if="id" class="flex flex-wrap">
                <div
                    v-if="$ability.hasPermission('product:Publish')"
                    class="w-full mt-3 flex justify-center sm:justify-start items-center"
                >
                    <active-selector
                        v-model="productComponent.active"
                        :enabled="enabledUpdate"
                        :weight="parseInt(productComponent.weight)"
                        :public-url="publicProductUrl"
                        :public-label="publicProductLabel"
                        require-weight
                        on-label="Publicado"
                        off-label="Oculto"
                        activate-title="¿Quieres habilitar el producto?"
                        activate-hint="Recuerda cargar imágenes para cada referencia habilitada del producto, de esta forma será más atractivo. Selecciona la página y el peso donde quieres que aparezca el producto en el listado."
                        confirm-label="Publicar producto"
                        @change="publishComponent"
                        @weight-change="productComponent.weight = $event"
                        @page-change="
                            productComponent.weight = ($event - 1) * 12 + 1
                        "
                    />
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div class="md:col-span-2">
                    <custom-input
                        v-model="productComponent.name"
                        label="Nombre"
                        class="w-full"
                        :disabled="disabledUpdate"
                        :error="
                            !isValidName & introValidators.name
                                ? 'Nombre invalido'
                                : ''
                        "
                        @blur="setSlug"
                    />
                </div>

                <div>
                    <custom-input
                        v-model="productComponent.sku"
                        label="SKU"
                        class="w-full"
                        :disabled="disabledUpdate"
                    />
                </div>
            </div>

            <div class="mt-4">
                <custom-input
                    v-model="productComponent.summary"
                    label="Descripción"
                    :disabled="disabledUpdate"
                    :error="
                        !isValidShortDescription & introValidators.summary
                            ? 'Descripción invalida. Debe tener mínimo 1 caracter máximo 255'
                            : ''
                    "
                    @blur="introValidators.summary = true"
                />
            </div>

            <div
                v-if="loadProduct || !id"
                class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4"
            >
                <brand-selector
                    v-model="productComponent.brand"
                    :enabled="enabledBrandUpdate"
                />
                <product-type-selector
                    v-model="productComponent.type"
                    :enabled="enabledUpdate"
                    :allowed-types="allowedProductTypes"
                />
                <custom-input
                    v-model="productComponent.taxRate"
                    label="Porcentaje de impuestos aplicados (%)"
                    :disabled="disabledUpdate"
                />

                <fragment v-if="$enabledEcommerceOptions">
                    <div v-if="showCustomReference">
                        <custom-input
                            v-model="productComponent.customReferenceTitle"
                            class="w-full"
                            label="Nombre de la variante personalizada"
                            :disabled="disabledUpdate"
                            @blur="trimCustomReferenceTitle"
                        />
                    </div>

                    <div v-if="hasTagsScope">
                        <tags-selector
                            v-if="hasTagsCatalogScope"
                            v-model="productComponent.tags"
                            :tags="tenantTagsCatalog"
                            :enabled="enabledTagsUpdate"
                            :creating="isCreatingTag"
                            allow-create
                            label="Etiquetas"
                            @create="handleCreateTag"
                        />
                        <keywords-manage
                            v-else
                            v-model="productComponent.tags"
                            :enabled="enabledTagsUpdate"
                            label="Etiquetas"
                            description="Las etiquetas permiten marcar este producto con palabras clave adicionales para que aparezca en búsquedas por otros términos relacionados, distintos a su nombre o colección."
                        />
                    </div>

                    <div v-if="isEcommercePro && $data.$targetGroupFilterLabel">
                        <options-selector
                            v-model="productComponent.targetGroups"
                            :enabled="enabledUpdate"
                            :base="Object.keys($data.$targetGroupsCodes)"
                            :label="$data.$targetGroupFilterLabel"
                        />
                    </div>
                </fragment>
            </div>

            <div v-if="enabledUpdate" class="mt-6 flex justify-center">
                <app-button
                    v-if="!id"
                    size="large"
                    @click="recordProductComponent"
                >
                    Crear producto
                </app-button>
                <app-button v-else size="large" @click="updateProductComponent">
                    Actualizar producto
                </app-button>
            </div>
        </div>

        <div v-if="activeTab === 'seo'" id="seoTab" class="space-y-6">
            <div id="seo-title" class="flex flex-wrap">
                <div class="flex flex-col">
                    <h2 class="text-theme-primary text-2xl font-semibold mt-3">
                        Contenido del producto
                    </h2>
                    <span class="mt-4">
                        Este contenido es el que se va a mostrar en la página
                        del producto, es importante que este bien redactado y
                        sea atractivo para los usuarios, ya que esto va a
                        influir en la decisión de compra de los usuarios.
                    </span>
                </div>
            </div>

            <div
                class="rounded-2xl shadow-sm py-2 px-4"
                :class="disabledUpdate ? 'bg-theme-card' : ''"
            >
                <div v-if="$enabledEcommerceOptions && hasContentScope">
                    <markdown-editor
                        v-model="productComponent.content"
                        :enabled="enabledContentUpdate"
                    />
                </div>
            </div>

            <div v-if="$enabledEcommerceOptions && hasContentScope">
                <h2
                    class="text-theme-primary text-xl font-semibold mb-4 flex items-center gap-2"
                >
                    Palabras clave
                </h2>

                <keywords-manage
                    v-model="productComponent.keywords"
                    :base="$data.$keywordsBase"
                    :enabled="enabledContentUpdate"
                />
            </div>

            <div class="rounded-3xl shadow-sm p-3 mt-5">
                <div
                    v-if="$enabledEcommerceOptions && hasContentScope"
                    class="flex flex-wrap"
                >
                    <h2
                        class="text-theme-primary text-xl font-semibold mb-4 flex items-center gap-2"
                    >
                        Especificaciones
                    </h2>
                    <feature-manage
                        v-model="productComponent.features"
                        :enabled="enabledContentUpdate"
                        items-empty-message="Este producto no tiene características registradas"
                    />
                </div>
            </div>

            <div v-if="enabledUpdate" class="w-full flex justify-center">
                <app-button
                    :loading="isLoadingContent"
                    @click="updateProductContentComponent"
                >
                    Actualizar Contenido
                </app-button>
            </div>
        </div>

        <div v-if="activeTab === 'references'" id="referencesTab">
            <div id="reference-title" class="flex flex-wrap">
                <div class="flex flex-col">
                    <h2 class="text-theme-primary text-2xl font-semibold mt-4">
                        Variantes del producto
                    </h2>
                    <span class="mt-4">
                        Las referencias | variantes representan cada una de las
                        combinaciones de color y tamaño que tenga el producto.
                        Puede tener un precio diferente al producto base y un
                        stock diferente también.
                    </span>
                    <wiki-learn-more-link topic="variantes" class="mt-2" />
                </div>
            </div>

            <div v-if="loadProduct && !isLoading" class="flex flex-wrap mt-4">
                <reference-manage
                    v-for="(reference, index) in productComponent.references"
                    :key="index"
                    :product="{
                        name: productComponent.name,
                        type: productComponent.type
                    }"
                    :reference="reference"
                    :open-reference-id="openReferenceId"
                    :default-reference-id="defaultReferenceId"
                    :enabled="enabledUpdate || reference.id === 0"
                    :custom-reference-title="
                        productComponent.customReferenceTitle
                    "
                    :references-count="productComponent.references.length"
                    :inventory-mode="inventoryMode"
                    @changeActive="changeActiveQuery($event)"
                    @remove="removeReference($event)"
                    @update="changeReference($event)"
                    @created="createdReference($event)"
                    @goToReference="openProduction($event)"
                    @setDefault="setDefaultReferenceComponent($event)"
                />
                <div class="w-full flex justify-center mt-5">
                    <custom-tooltip
                        v-if="
                            hasGlobalScope &&
                            productComponent.type !== 'single' &&
                            $ability.hasPermission('reference:Create') &&
                            enabledUpdate
                        "
                        border
                    >
                        <button
                            class="flex justify-center items-center btn border border-theme-border p-4"
                            @click="createNewReference"
                        >
                            ➕
                        </button>
                        <template #tooltip> Nueva referencia </template>
                    </custom-tooltip>
                </div>
            </div>
        </div>

        <div v-if="activeTab === 'routes'" id="routesTab">
            <div
                v-if="
                    $ability.hasPermission('product:UpdateLine') &&
                    $ability.hasPermission('line:List')
                "
                id="line-container"
                class="mb-14"
            >
                <div id="line-title" class="flex flex-wrap">
                    <div class="flex flex-col">
                        <h2
                            class="text-theme-primary text-2xl font-semibold mt-4"
                        >
                            Categoría del producto
                        </h2>
                        <span class="mt-4">
                            Las categorías te ayudarán a agrupar y clasificar
                            los productos de manera eficiente. Por ejemplo,
                            puedes utilizar la categoría "Tecnología" y la
                            subcategoría "Telefonos" para una organización más
                            detallada.
                        </span>
                        <wiki-learn-more-link
                            topic="lineas-y-sublineas"
                            class="mt-2"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap mt-2">
                    <line-subline-manage
                        v-model="productComponent.subline"
                        :product-id="id"
                        :enabled="
                            enabledUpdate && $ability.hasPermission('line:List')
                        "
                    />
                </div>
            </div>
            <div
                v-if="
                    $ability.hasPermission('product:UpdateCollections') &&
                    $ability.hasPermission('collection:List') &&
                    productComponent.active
                "
                id="collections-container"
                class="mt-4"
            >
                <div id="collections-title" class="flex flex-wrap">
                    <div class="flex flex-col">
                        <h2 class="text-theme-primary text-2xl font-semibold">
                            Colecciones del producto
                        </h2>
                        <span class="mt-4">
                            Las colecciones determinan los productos que seran
                            cargados despues de la carga inicial del producto.
                            Los productos pueden agruparse por el personaje
                            principal, por la serie o anime, el colegio del
                            producto o cualquier característica que permita
                            agrupar a productos de diferentes categorías.
                        </span>
                    </div>
                </div>
                <div class="flex flex-wrap mt-2">
                    <collections-manage
                        v-model="productComponent.collections"
                        :enabled="enabledUpdate"
                    >
                        <template slot="action">
                            <app-button
                                :loading="isLoadingCollections"
                                class="mt-4"
                                @click="updateCollectionsProducts"
                            >
                                Actualizar Colecciones
                            </app-button>
                        </template>
                    </collections-manage>
                </div>
            </div>
        </div>

        <div v-if="activeTab === 'files'" id="filesTab">
            <div id="files-container">
                <div id="files-title" class="flex flex-wrap">
                    <div class="flex flex-col">
                        <h2
                            class="text-theme-primary text-2xl font-semibold mt-4"
                        >
                            Archivos adjuntos para el producto
                        </h2>
                        <span class="mt-4">
                            En esta sección puedes asociar archivos a tu
                            producto como guias de tallas, manual de uso o
                            cualquier otro archivo que ayude al cliente a saber
                            más información del producto. Los archivos cargados
                            tiendaados en la nube y tendrán libre acceso.
                        </span>
                    </div>
                </div>
                <div>
                    <files-manage
                        :id="`${productComponent.id}`"
                        v-model="productComponent.files"
                        :enabled="enabledUpdate"
                        class="mt-4"
                    />
                    <div class="flex justify-center">
                        <app-button
                            v-if="enabledUpdate"
                            :loading="isLoadingFiles"
                            class="mt-4"
                            @click="updateFilesProduct"
                        >
                            Actualizar archivos
                        </app-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="activeTab === 'extraOptions'" id="extraOptionsTab">
            <div id="extra-options-container">
                <div id="extra-options-title" class="flex flex-wrap">
                    <div class="flex flex-col">
                        <h2
                            class="text-theme-primary text-2xl font-semibold mt-4"
                        >
                            Opciones Extra
                        </h2>
                        <span class="mt-4">
                            Agrega opciones extra para que el cliente pueda
                            seleccionar o especificar al realizar la compra de
                            un producto. Estas opciones pueden incluir elementos
                            como cubiertos para comidas, la selección de bebidas
                            en combos, elegir un diseño personalizado para ropa,
                            o añadir un mensaje especial al producto. Cada
                            opción puede ser personalizada para adaptarse a las
                            necesidades del cliente, ofreciendo una experiencia
                            de compra más completa y flexible.
                        </span>
                    </div>
                    <div class="lg:w-10/12 w-full mt-6 mx-auto">
                        <product-extra-options-manager
                            v-model="productComponent.extraOptions"
                            :enabled="enabledUpdate"
                        />
                    </div>

                    <div class="w-full my-3 flex justify-center">
                        <app-button
                            v-if="enabledUpdate"
                            class="mx-auto"
                            @click="updateExtraOptionsComponent"
                        >
                            Actualizar opciones
                        </app-button>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="activeTab === 'delivery'"
            id="deliveryTab"
            class="space-y-10"
        >
            <div id="delivery-container">
                <h2 class="text-theme-primary text-2xl font-semibold">
                    Configuración logística
                </h2>
                <span class="mt-2 block">
                    Selecciona la configuración logistica para establecer
                    tiempos de entrega y costos adicionales en la compra de un
                    producto.
                </span>

                <div class="lg:w-8/12 md:w-10/12 w-full mt-6 mx-auto">
                    <logistic-configuration-selector
                        v-model="productComponent.logisticConfiguration"
                        :enabled="enabledUpdate"
                        label=""
                    />
                </div>

                <div class="w-full mt-6 flex justify-center">
                    <app-button
                        v-if="enabledUpdate"
                        @click="updateProductDeliveryComponent"
                    >
                        Actualizar configuración
                    </app-button>
                </div>
            </div>

            <div id="delivery-simulation">
                <h2 class="text-theme-primary text-2xl font-semibold">
                    Simulación de entrega
                </h2>
                <span class="mt-2 block">
                    Simula las fechas de entrega para la referencia por defecto
                    del producto según la configuración logística asignada.
                </span>
                <div class="mt-6">
                    <delivery-simulator
                        :logistic-configuration-slug="
                            productComponent.logisticConfiguration
                                ? productComponent.logisticConfiguration.slug
                                : null
                        "
                        :initial-price-offer="referenceComponent.priceOffer"
                        :initial-always-stock="referenceComponent.alwaysStock"
                    />
                </div>
            </div>
        </div>

        <app-dialog v-model="isOpenPricesModal">
            <template #header>
                <h2 class="mx-4 text-xl font-medium text-center">
                    Asignar precios para todas las referencias
                </h2>
            </template>
            <div class="mx-2 mt-4">
                <price-offer-fields
                    v-model="defaultPrices"
                    class="w-full lg:w-10/12 mx-auto"
                    :show-errors="pricesShowErrors"
                    @error-change="pricesHaveError = $event"
                />
            </div>
            <template #footer>
                <div class="con-footer flex justify-center my-2">
                    <app-button
                        :disabled="pricesHaveError"
                        @click="updateProductPricesComponent"
                    >
                        Actualizar precios
                    </app-button>
                </div>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import planLimitError from "@/mixins/planLimitError";
import tabQuerySyncMixin from "@/mixins/tabQuerySyncMixin";
import { mapActions, mapGetters } from "vuex";

import {
    TARGET_GROUP_FILTER_LABEL,
    TARGET_GROUP_LABELS
} from "@/common/constants";
import { keywordsBase } from "@/common/fields/keywords-base";
import { OperationsModes } from "@/common/fields/operations-modes";
import { productTypesReferenceConfig } from "@/common/fields/product-types";
import { slugRegex, summaryRegex, titleRegex } from "@/common/lib/regex";
import { slugify } from "@/common/lib/transformers";
import { stripUrlProtocol } from "@/common/lib/url";

import BrandSelector from "@/components/brands/BrandSelector.vue";
import CollectionsManage from "@/components/collections/CollectionsManage.vue";
import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import LineSublineManage from "@/components/lines/LineSublineManage.vue";
import DeliverySimulator from "@/components/logistic-configurations/DeliverySimulator.vue";
import LogisticConfigurationSelector from "@/components/logistic-configurations/LogisticConfigurationSelector.vue";
import ProductExtraOptionsManager from "@/components/products/ProductExtraOptionsManage.vue";
import ProductTypeSelector from "@/components/products/ProductTypeSelector.vue";
import ReferenceManage from "@/components/references/ReferenceManage.vue";
import ActiveSelector from "@/components/utils/ActiveSelector.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import FeatureManage from "@/components/utils/FeatureManage.vue";
import FilesManage from "@/components/utils/FilesManage.vue";
import KeywordsManage from "@/components/utils/KeywordsManage.vue";
import MarkdownEditor from "@/components/utils/MarkdownEditor.vue";
import OptionsSelector from "@/components/utils/OptionsSelector.vue";
import PriceOfferFields from "@/components/utils/PriceOfferFields.vue";
import TagsSelector from "@/components/utils/TagsSelector.vue";
import WikiLearnMoreLink from "@/components/utils/WikiLearnMoreLink.vue";

export default {
    name: "CreateUpdateProduct",
    components: {
        AppDialog,
        ReloadIcon,
        FilesManage,
        BrandSelector,
        FeatureManage,
        ActiveSelector,
        MarkdownEditor,
        ReferenceManage,
        KeywordsManage,
        CollectionsManage,
        LineSublineManage,
        ProductTypeSelector,
        PriceOfferFields,
        DeliverySimulator,
        LogisticConfigurationSelector,
        ProductExtraOptionsManager,
        WikiLearnMoreLink,
        OptionsSelector,
        TagsSelector,
        CustomInput
    },
    mixins: [tabQuerySyncMixin, planLimitError],
    data: () => ({
        id: 0,
        name: "",
        activeTab: "general",
        isLoadingContent: false,
        taxRate: 0,
        isLoading: false,
        loadProduct: false,
        allowedProductTypes: [],
        inventoryMode: null,
        openReferenceId: 0,
        defaultReferenceId: 0,
        enabledUpdate: false,
        isLoadingCollections: false,
        isOpenPricesModal: false,
        isLoadingFiles: false,
        isLoadingPrice: false,
        $keywordsBase: keywordsBase,
        $targetGroupFilterLabel: TARGET_GROUP_FILTER_LABEL,
        $targetGroupsCodes: TARGET_GROUP_LABELS,
        referenceComponent: {
            price: 0,
            priceOffer: 0,
            cost: 0,
            alwaysStock: false
        },
        pricesHaveError: false,
        pricesShowErrors: false,
        hasGlobalScope: false,
        hasBrandScope: false,
        hasTagsScope: false,
        hasContentScope: false,
        tenantTagsCatalog: [],
        isCreatingTag: false,
        introValidators: { slug: false, name: false, summary: false },
        productComponent: {
            id: 0,
            sku: "",
            slug: "",
            name: "",
            type: "single",
            price: 0,
            weight: 120,
            targetGroups: [],
            tags: [],
            keywords: [],
            createdAt: "",
            features: [],
            updatedAt: "",
            deletedAt: undefined,
            active: false,
            priceOffer: 0,
            content: "",
            customReferenceTitle: null,
            files: [],
            references: [
                {
                    pricePrime: 0,
                    priceOffer: 53000,
                    price: 63600,
                    cost: 48000,
                    priceWholesale: 53000,
                    stock: 12,
                    alwaysStock: true,
                    id: 499,
                    barcode: "DS3231S",
                    size: "0",
                    color: "rojo",
                    colorRef: "#000",
                    productId: 420,
                    minUnitsForPriceWholesale: 0,
                    isDefault: true,
                    active: true,
                    createdAt: "2023-01-19T23:22:31.625Z",
                    updatedAt: "2023-01-29T17:13:20.790Z",
                    customReferenceValue: null,
                    images: [
                        {
                            id: 215,
                            url: "https://parsek-pro-public-files-bucket.s3.us-east-2.amazonaws.com/large/643998995.jpg",
                            alt: "DS3231SSMD",
                            size: "squareImage",
                            sequence: {
                                sequence: 0
                            }
                        },
                        {
                            id: 214,
                            url: "https://parsek-pro-public-files-bucket.s3.us-east-2.amazonaws.com/large/771354961.png",
                            alt: "Analog Devices",
                            size: "squareImage",
                            sequence: {
                                sequence: 2
                            }
                        }
                    ]
                }
            ],
            collections: [],
            extraOptions: [],
            summary: "",
            brand: {
                name: "",
                slug: ""
            },
            logisticConfiguration: {
                name: "",
                slug: ""
            },
            subline: {
                slug: "",
                name: "",
                summary: "",
                line: {
                    slug: "",
                    name: "",
                    summary: ""
                }
            },
            productTypeReferenceConfig: {
                showSize: false,
                showColor: false,
                showCustomReference: true,
                sizeLabel: "Tamaño",
                colorLabel: "Color",
                sizeLabelPlural: "Tamaños",
                colorLabelPlural: "Colores"
            }
        },
        $tabsWhitelist: [
            "general",
            "seo",
            "references",
            "routes",
            "files",
            "extraOptions",
            "delivery"
        ]
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        defaultPrices: {
            get() {
                return {
                    price: this.referenceComponent.price,
                    priceOffer: this.referenceComponent.priceOffer,
                    cost: this.referenceComponent.cost
                };
            },
            set({ cost, price, priceOffer }) {
                this.referenceComponent.price = price;
                this.referenceComponent.priceOffer = priceOffer;
                this.referenceComponent.cost = cost;
            }
        },
        isEcommercePro() {
            return this.$operationMode === OperationsModes.ecommercePro;
        },
        publicProductUrl() {
            if (
                !this.id ||
                !this.productComponent.active ||
                !this.productComponent.slug ||
                !this.$publicUrl
            ) {
                return "";
            }
            return `${this.$publicUrl}/${this.productComponent.slug}`;
        },
        publicProductLabel() {
            return stripUrlProtocol(this.publicProductUrl);
        },
        isValidSlug() {
            return slugRegex.test(this.productComponent.slug);
        },
        isValidName() {
            return titleRegex.test(this.productComponent.name);
        },
        isValidShortDescription() {
            return summaryRegex.test(this.productComponent.summary);
        },
        showCustomReference() {
            const config =
                productTypesReferenceConfig[this.productComponent.type];
            return config ? config.showCustomReference : false;
        },
        disabledUpdate() {
            return !this.enabledUpdate;
        },
        enabledBrandUpdate() {
            return this.enabledUpdate && this.hasBrandScope;
        },
        enabledTagsUpdate() {
            return this.enabledUpdate && this.hasTagsScope;
        },
        hasTagsCatalogScope() {
            return (
                this.$ability.hasPermission("tenant:GetTagsSettings") &&
                this.$operationMode !== OperationsModes.multiTenant
            );
        },
        enabledContentUpdate() {
            return this.enabledUpdate && this.hasContentScope;
        }
    },
    watch: {
        "$route.params.id"(newId, oldId) {
            if (!newId || newId === oldId) return;
            this.id = Number(newId);
            this.name = "Cargando...";
            this.getBaseItem();
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        // `verifyStrictPermission` ya acepta la variante "todas las tiendas"
        // (`product:Update_`); pedirla directo no la cumple ningún rol.
        this.hasGlobalScope = this.$ability.hasPermission("product:Update");
        this.hasBrandScope = this.$ability.hasPermission("product:UpdateBrand");
        this.hasTagsScope = this.$ability.hasPermission("product:UpdateTags");
        this.hasContentScope = this.$ability.hasPermission(
            "product:UpdateContent"
        );
        this.loadAllowedProductTypes();
        this.loadInventoryMode();
        if (this.hasTagsScope && this.hasTagsCatalogScope) {
            await this.loadTenantTagsCatalog();
        }

        if ("id" in this.$route.params) {
            if (!(await verifyPagePermission("product:Get", "/app/products")))
                return;
            this.id = Number(this.$route.params.id);
            this.name = "Cargando...";
            await this.getBaseItem();
        } else if ("idClone" in this.$route.params) {
            if (
                !(await verifyPagePermission("product:Create", "/app/products"))
            )
                return;
            this.id = 0;
            this.enabledUpdate = true;
            this.id = Number(this.$route.params.idClone);
            await this.getBaseItem();
            this.productComponent = {
                ...this.productComponent,
                name: `${this.productComponent.name} CLONE`,
                slug: `${this.productComponent.slug}-clone`,
                sku: `${this.productComponent.sku}1`,
                active: false
            };

            this.$swal.fire({
                background: this.backgroundColor,
                title: "Estas clonando un producto",
                text: `Antes de guardar el producto asegurate de cambiar el nombre, sku y slug. Una vez hayas creado el producto pasa por todos los tab y guarda/actualiza toda la información, en especial cada referencia.

Recuerda el código de barras se guarda por referencia 📡.`,
                icon: "info",
                showCloseButton: true
            });
        } else {
            if (
                !(await verifyPagePermission("product:Create", "/app/products"))
            )
                return;
            this.id = 0;
            this.enabledUpdate = true;
            this.loadProduct = true;
        }
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantProductTypes",
            "getTenantInventorySettings",
            "getTenantTagsSettings",
            "updateTenantTagsSettings"
        ]),
        async loadAllowedProductTypes() {
            try {
                const data = await this.getTenantProductTypes();
                if (Array.isArray(data.allowedProductTypes)) {
                    this.allowedProductTypes = data.allowedProductTypes;
                }
            } catch {
                // fallback: show all types
            }
        },
        // sucursales-inventario-multitenant: decide si el stock de cada
        // referencia se edita (modo global) o es de solo lectura.
        async loadInventoryMode() {
            if (!this.$ability.hasPermission("tenant:GetInventorySettings"))
                return;
            try {
                const data = await this.getTenantInventorySettings();
                this.inventoryMode = data.inventoryMode || null;
            } catch {
                this.inventoryMode = null;
            }
        },
        async loadTenantTagsCatalog() {
            this.$loading.show();
            try {
                const data = await this.getTenantTagsSettings();
                this.tenantTagsCatalog = Array.isArray(data.tags)
                    ? data.tags
                    : [];
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async handleCreateTag(name) {
            const value = slugify(name);
            const existingTag = this.tenantTagsCatalog.find(
                (tag) => tag.value === value
            );
            if (existingTag) {
                if (!this.productComponent.tags.includes(value)) {
                    this.productComponent.tags = [
                        ...this.productComponent.tags,
                        value
                    ];
                }
                return;
            }
            this.isCreatingTag = true;
            try {
                await this.updateTenantTagsSettings({
                    tags: [...this.tenantTagsCatalog, { name, value }]
                });
                this.tenantTagsCatalog = [
                    ...this.tenantTagsCatalog,
                    { name, value }
                ];
                this.productComponent.tags = [
                    ...this.productComponent.tags,
                    value
                ];
                this.isCreatingTag = false;
            } catch (error) {
                this.isCreatingTag = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        ...mapActions("products", [
            "updateProduct",
            "createProduct",
            "deleteProduct",
            "deleteProductDefinitively",
            "getProductById",
            "publishProduct",
            "updateProductsFiles",
            "deleteReference",
            "setDefaultReference",
            "updateProductDelivery",
            "updateProductPrices",
            "updateProductExtraOptions",
            "updateProductsCollections"
        ]),
        trimCustomReferenceTitle() {
            const val = this.productComponent.customReferenceTitle;
            this.productComponent.customReferenceTitle = val
                ? val.trim() || null
                : null;
        },
        async setSlug() {
            this.introValidators.name = true;
            if (
                this.enabledUpdate &&
                this.productComponent.name &&
                !this.productComponent.active
            ) {
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Quieres cambiar el slug ?",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#02913f",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Si",
                    cancelButtonText: "No"
                });
                if (dialogResult.isConfirmed) {
                    this.productComponent.slug = slugify(
                        this.productComponent.name
                    );
                }
            }
        },
        async deleteItemComponent() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Seguro deseas eliminar el producto ?",
                text: "Recuerda se va a eliminar tu producto y puedes perder tiempo 🗑️",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#02913f",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si",
                cancelButtonText: "No"
            });
            if (dialogResult.isConfirmed) {
                this.isLoading = true;
                this.$loading.show();
                try {
                    await this.deleteProduct({
                        id: this.productComponent.id
                    });
                    this.$toast.success({
                        title: `Producto # ${this.productComponent.id} eliminado`
                    });
                    this.$router.push("/app/products");
                    this.$loading.hide();
                    this.isLoading = false;
                } catch (error) {
                    this.$loading.hide();
                    this.isLoading = false;
                    this.$loading.hide();
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        },
        async deleteItemDefinitelyComponent() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Seguro ?",
                text: "Recuerda se va a eliminar tu producto definitivamente y puedes perder tiempo 🗑️",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#02913f",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si",
                cancelButtonText: "No"
            });
            if (dialogResult.isConfirmed) {
                this.isLoading = true;
                this.$loading.show();
                try {
                    await this.deleteProductDefinitively({
                        id: this.productComponent.id
                    });
                    this.$toast.success({
                        title: `Producto # ${this.productComponent.id} eliminado`
                    });
                    this.$router.push("/app/products");
                    this.$loading.hide();
                    this.isLoading = false;
                } catch (error) {
                    this.$loading.hide();
                    this.isLoading = false;
                    this.$loading.hide();
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        },
        async getBaseItem() {
            this.isLoading = true;
            this.$loading.show();
            try {
                let result = await this.getProductById({
                    id: this.id
                });
                this.name = result.name;
                this.productComponent = { ...result };
                this.applyDefaultReference();
                this.isLoading = false;
                this.loadProduct = true;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/products");
                }
            }
        },
        async updateFilesProduct() {
            this.isLoadingFiles = true;
            try {
                await this.updateProductsFiles({
                    productId: this.productComponent.id,
                    filesIds: this.productComponent.files.map((item) => ({
                        id: item.id
                    }))
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoadingFiles = false;
            } catch (error) {
                this.isLoadingFiles = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateCollectionsProducts() {
            this.isLoadingCollections = true;
            try {
                await this.updateProductsCollections({
                    productId: this.productComponent.id,
                    collectionsSlugs: this.productComponent.collections.map(
                        (item) => ({ slug: item.slug })
                    )
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoadingCollections = false;
            } catch (error) {
                this.isLoadingCollections = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async setDefaultReferenceComponent(referenceId) {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.setDefaultReference({
                    referenceId,
                    productId: this.productComponent.id
                });
                this.defaultReferenceId = referenceId;
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateProductComponent() {
            if (!this.validateData()) {
                return;
            }
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateProduct({
                    id: this.productComponent.id,
                    name: this.productComponent.name,
                    sku: this.productComponent.sku,
                    summary: this.productComponent.summary,
                    ...(this.hasBrandScope
                        ? { brand: this.productComponent.brand }
                        : {}),
                    type: this.productComponent.type,
                    ...(this.hasTagsScope
                        ? { tags: this.productComponent.tags }
                        : {}),
                    targetGroups: this.productComponent.targetGroups,
                    madeIn: this.productComponent.madeIn,
                    taxRate: this.productComponent.taxRate,
                    weight: this.productComponent.weight,
                    customReferenceTitle:
                        this.productComponent.customReferenceTitle
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateExtraOptionsComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateProductExtraOptions({
                    id: this.productComponent.id,
                    extraOptions: this.productComponent.extraOptions
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateProductDeliveryComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateProductDelivery({
                    id: this.productComponent.id,
                    logisticConfigurationSlug:
                        this.productComponent.logisticConfiguration.slug
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateProductPricesComponent() {
            if (this.pricesHaveError) {
                this.pricesShowErrors = true;
                return;
            }
            this.isOpenPricesModal = false;
            this.$loading.show();

            try {
                await this.updateProductPrices({
                    id: this.productComponent.id,
                    price: this.referenceComponent.price,
                    priceOffer: this.referenceComponent.priceOffer,
                    cost: this.referenceComponent.cost
                });

                this.$loading.hide();
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.productComponent.references =
                    this.productComponent.references.map((item) => ({
                        ...item,
                        price: this.referenceComponent.price,
                        priceOffer: this.referenceComponent.priceOffer
                    }));
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateProductContentComponent() {
            this.isLoadingContent = true;
            this.$loading.show();
            try {
                await this.updateProduct({
                    id: this.productComponent.id,
                    slug: this.productComponent.slug,
                    ...(this.hasContentScope
                        ? {
                              content: this.productComponent.content,
                              keywords: this.productComponent.keywords,
                              features: this.productComponent.features
                          }
                        : {}),
                    ...(this.hasBrandScope
                        ? { brand: this.productComponent.brand }
                        : {})
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoadingContent = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoadingContent = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async publishComponent() {
            if (this.productComponent.active) {
                if (this.productComponent.references.length < 1) {
                    this.productComponent.active = false;
                    return this.$swal.fire({
                        background: this.backgroundColor,
                        title: "Variantes",
                        text: "Debes de tener como mínimo una referencia para activar el producto",
                        icon: "info"
                    });
                }
            }

            this.isLoading = true;
            this.$loading.show();
            try {
                await this.publishProduct(this.productComponent);
                this.$sound.play();
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.productComponent.active = !this.productComponent.active;
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async recordProductComponent() {
            if (!this.validateData()) {
                return;
            }
            this.isLoading = true;
            this.$loading.show();
            try {
                const data = await this.createProduct(this.productComponent);
                this.$sound.play();
                this.isLoading = false;
                this.$loading.hide();
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: `Producto creado con el ID: ${data.id}`,
                    text: "Deseas ir al detalle del producto registrado o continuar agregando productos ?",
                    icon: "success",
                    showClass: {
                        popup: "animate__animated animate__fadeInDown"
                    },
                    hideClass: {
                        popup: "animate__animated animate__fadeOutUp"
                    },
                    focusConfirm: false,
                    showDenyButton: true,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: "#02672D",
                    cancelButtonColor: "#253C99",
                    denyButtonColor: "#d33ddd",
                    confirmButtonText: "Ver detalle",
                    denyButtonText: "Ir a lista de productos",
                    cancelButtonText: "Nuevo producto",
                    allowOutsideClick: false
                });
                if (dialogResult.isConfirmed) {
                    this.productComponent = {
                        ...data,
                        ...this.productComponent
                    };
                    this.id = data.id;
                    this.name = this.productComponent.name;
                    this.$router.push(`/app/products/detail/${this.id}`);
                }
                if (dialogResult.isDenied) {
                    this.$router.push("/app/products/");
                }
                if (dialogResult.isDismissed) {
                    this.resetItem();
                }
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                if (this.openPlanUpgradeForLimit(error)) return;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async setPriceToAllReferencesComponent() {},
        openPricesModal() {
            this.isOpenPricesModal = true;
        },
        openSalesProductComponent() {
            if (this.id) {
                window.open(`/app/orders/product/${this.id}`, "_blank").focus();
            }
        },
        openProduction(complement) {
            window
                .open(
                    `${this.$publicUrl}/${this.productComponent.slug}${complement}`,
                    "_blank"
                )
                .focus();
        },
        applyDefaultReference() {
            if (this.productComponent.references.length) {
                let defaultReference = this.productComponent.references[0];
                const referenceIdToSearch = this.$route.query.reference;
                if (referenceIdToSearch) {
                    const searchedReference =
                        this.productComponent.references.find(
                            (item) => item.id === Number(referenceIdToSearch)
                        );
                    if (searchedReference) {
                        defaultReference = searchedReference;
                    }
                } else {
                    const defaultSearchedReference =
                        this.productComponent.references.find(
                            (item) => item.isDefault
                        );
                    if (defaultSearchedReference) {
                        defaultReference = defaultSearchedReference;
                    }
                }
                this.defaultReferenceId = defaultReference.id;
                this.referenceComponent.cost = defaultReference.cost;
                this.referenceComponent.price = defaultReference.price;
                this.referenceComponent.priceOffer =
                    defaultReference.priceOffer;
                this.referenceComponent.alwaysStock =
                    defaultReference.alwaysStock;
                this.changeActiveQuery(defaultReference.id);
            }
        },
        changeActiveQuery(referenceId) {
            let currentUrl = new URL(window.location.href);
            if (!referenceId) {
                currentUrl.searchParams.delete("reference");
            } else {
                currentUrl.searchParams.set("reference", referenceId);
            }
            window.history.replaceState({}, "", currentUrl);
            this.openReferenceId = referenceId;
        },
        getNewBarcode() {
            const cleanBarcodes = this.productComponent.references.map(
                (item) => item.barcode
            );
            const isNumeric = (str) => /^\d+$/.test(str);

            const sorted = cleanBarcodes.sort((a, b) => {
                const aIsNum = isNumeric(a);
                const bIsNum = isNumeric(b);

                if (aIsNum && bIsNum) return Number(a) - Number(b);
                return a.localeCompare(b);
            });

            const last = sorted[sorted.length - 1];

            if (last === "") {
                return "";
            }

            if (isNumeric(last)) {
                return (Number(last) + 1).toString();
            } else {
                return last + "0";
            }
        },
        createNewReference() {
            if (this.productComponent.references.length > 0) {
                // Sin precio al por mayor: se activa a mano en la referencia.
                this.productComponent.references.push({
                    ...this.productComponent.references[0],
                    priceWholesale: null,
                    minUnitsForPriceWholesale: undefined,
                    stockMerchant: 0,
                    stock: 0,
                    active: false,
                    id: 0,
                    barcode: this.getNewBarcode()
                });
            } else {
                this.productComponent.references.push({
                    active: false,
                    priceWholesale: null,
                    stock: 0,
                    color: "blanco",
                    colorRef: "#fff",
                    createdAt: "",
                    updatedAt: "",
                    default: false,
                    id: 0,
                    images: [],
                    price: this.productComponent.price,
                    priceOffer: this.productComponent.priceOffer,
                    productId: this.productComponent.id,
                    size: "unico",
                    priceMerchant: this.productComponent.price,
                    priceOfferMerchant: this.productComponent.priceOffer
                });
            }
            this.openReferenceId = 0;
        },
        createdReference(reference) {
            if (this.$route.fullPath.includes("new")) {
                this.defaultReferenceId = reference.id;
            }
            this.productComponent.references.pop();
            this.productComponent.references.push(reference);
        },
        changeReference(reference) {
            const index = this.productComponent.references.findIndex(
                (item) => item.id === reference.id
            );
            let references = [...this.productComponent.references];
            references[index] = {
                ...reference
            };
            this.productComponent.references = [...references];
        },
        async removeReference({ id }) {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.deleteReference({
                    referenceId: id
                });
                this.$toast.success({ title: `Variante # ${id} eliminada` });
                this.productComponent.references =
                    this.productComponent.references.filter(
                        (item) => item.id !== id
                    );
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                this.$sound.play("error");
            }
        },
        validateData() {
            this.introValidators = {
                slug: true,
                name: true,
                summary: true
            };
            const toComplete = [];
            if (!this.isValidName) {
                toComplete.push("Nombre");
            }

            if (!this.productComponent.brand.slug) {
                toComplete.push("Marca");
            }

            if (!this.isValidShortDescription) {
                toComplete.push("Descripción");
            }

            if (this.productComponent.type === "") {
                toComplete.push("Tipo");
            }

            if (toComplete.length) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Producto invalido",
                    text: `Revisa por favor que todo este completo. Valida los siguientes campos: ${toComplete.join(
                        ", "
                    )}`,
                    icon: "info"
                });
                return false;
            }
            return true;
        },
        closePriceModal() {
            this.isOpenPricesModal = false;
        },
        resetItem() {
            this.introValidators = { slug: false };
            this.productComponent = {
                id: 0,
                sku: "",
                slug: "",
                name: "",
                type: "single",
                price: 0,
                weight: 120,
                targetGroups: [],
                tags: [],
                keywords: [],
                createdAt: "",
                features: [],
                updatedAt: "",
                active: false,
                priceOffer: 0,
                content: "",
                files: [],
                references: [],
                collections: [],
                summary: "",
                brand: {
                    name: "",
                    slug: ""
                },
                subline: {
                    slug: "",
                    name: "",
                    summary: "",
                    line: {
                        id: "",
                        name: "",
                        summary: ""
                    }
                }
            };
        }
    }
};
</script>
